export default "__VITE_ASSET__SuAnRQfM__"